import { render, staticRenderFns } from "./uxExperiencePanel.vue?vue&type=template&id=327e6c54&"
import script from "./uxExperiencePanel.vue?vue&type=script&lang=js&"
export * from "./uxExperiencePanel.vue?vue&type=script&lang=js&"
import style0 from "./uxExperiencePanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports